import * as yup from 'yup'

const OfficiantValidationSchema = yup.object().shape({
    companyName: yup
        .string()
        .required('Le nom de l\'entreprise est requis')
        .min(2, 'Le nom doit faire au moins 2 caractères'),
    nom: yup
        .string()
        .required('Le nom est requis'),
    prenom: yup
        .string()
        .required('Le prenom est requis'),
    Denomination: yup
        .string()
        .required('Le denomination est requis'),
    legalForm: yup.string().required('La forme juridique est requise'),
    capital: yup
        .number()
        .required('Le capital est requis')
        .positive('Le capital doit être positif'),
    dateofficiant: yup
        .string()
        .required('Le date est requis'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
    address: yup.string().required('L\'adresse est requise'),
    registrationOffice: yup.string().required('Le bureau d\'enregistrement est requis')
});

export default OfficiantValidationSchema;